import Navbar from "../../components/feature/Navbar";
import CartDrawer from "../../components/feature/CartDrawer";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BrandFeatures from "./components/BrandFeatures";
import FeaturedProducts from "./components/FeaturedProducts";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <CartDrawer />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <BrandFeatures />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
